import React, { useReducer } from 'react';
import PropTypes from 'prop-types';
import JotsContext from './JotsContext';

const initialState = {
    jotOnStage: undefined,
    setJotOnStage: () => {},
    jotToDelete: undefined,
    setJotToDelete: () => {},
    jotToUpdate: undefined,
    setJotToUpdate: () => {},
    jotToEdit: undefined,
    setJotToEdit: () => {},
};

const actions = {
    SET_JOT_ON_STAGE: 'SET_JOT_ON_STAGE',
    SET_JOT_TO_DELETE: 'SET_JOT_TO_DELETE',
    SET_JOT_TO_UPDATE: 'SET_JOT_TO_UPDATE',
    SET_JOT_TO_EDIT: 'SET_JOT_TO_EDIT',
};

const reducer = (state, action) => {
    switch (action.type) {
        case actions.SET_JOT_ON_STAGE:
            return { ...state, jotOnStage: action.jotId };
        case actions.SET_JOT_TO_DELETE:
            return { ...state, jotToDelete: action.jotId };
        case actions.SET_JOT_TO_UPDATE:
            return { ...state, jotToUpdate: action.jotId };
        case actions.SET_JOT_TO_EDIT:
            return { ...state, jotToEdit: action.jotId };
        default:
            return state;
    }
};

const JotsProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const value = {
        jotOnStage: state.jotOnStage,
        setJotOnStage: (jotId) => {
            dispatch({ type: actions.SET_JOT_ON_STAGE, jotId });
        },
        jotToDelete: state.jotToDelete,
        setJotToDelete: (jotId) => {
            dispatch({ type: actions.SET_JOT_TO_DELETE, jotId });
        },
        jotToUpdate: state.jotToUpdate,
        setJotToUpdate: (jotId) => {
            dispatch({ type: actions.SET_JOT_TO_UPDATE, jotId });
        },
        jotToEdit: state.jotToEdit,
        setJotToEdit: (jotId) => {
            dispatch({ type: actions.SET_JOT_TO_EDIT, jotId });
        },
    };

    return <JotsContext.Provider value={value}>{children}</JotsContext.Provider>;
};

JotsProvider.propTypes = {
    children: PropTypes.node,
};

JotsProvider.defaultProps = {
    children: undefined,
};

export default JotsProvider;
